import { render, staticRenderFns } from "./AlarmNoticeTableButton.vue?vue&type=template&id=153a9093&"
import script from "./AlarmNoticeTableButton.vue?vue&type=script&lang=js&"
export * from "./AlarmNoticeTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports